'use client';

import { XMarkIcon } from '@heroicons/react/24/outline';
import type { FC } from 'react';

import Logo from '@/components/icons/Logo';

type TSidebarHeader = {
  onClose: (value: boolean) => void;
  withLogo?: boolean;
};

const SidebarHeader: FC<TSidebarHeader> = ({ onClose, withLogo = true }) => {
  return (
    <div className='flex items-center justify-between px-6 pt-6 pb-3 bg-white dark:bg-gray-900'>
      {withLogo && <Logo height={32} />}
      <button
        type='button'
        onClick={() => onClose(false)}
        className='-m-2.5 rounded-md p-2.5 text-gray-700 dark:text-gray-400 focus:outline-none'
      >
        <span className='sr-only'>Close menu</span>
        <XMarkIcon aria-hidden='true' className='h-6 w-6' />
      </button>
    </div>
  );
};

export default SidebarHeader;
